// extracted by mini-css-extract-plugin
export default {"headerAuth":"HeaderAuth_headerAuth__ET48b"};